// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1083bede","703":"f0ec90eb","787":"2ab827d3"}[chunkId] + ".chunk.js";
};